export const DATE_TIME_FORMAT: { [key: string]: Intl.DateTimeFormatOptions } = {
  DAY_MONTH: {
    day: 'numeric',
    month: 'short',
  },
  DAY_MONTH_WEEKDAY: {
    day: 'numeric',
    month: 'short',
    weekday: 'long',
  },
  DAY_MONTH_WEEKDAY_YEAR: {
    day: 'numeric',
    month: 'short',
    weekday: 'long',
    year: 'numeric',
  },

  SUBSCRIPTION_LONG_DATE: {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  },
}

export const DAYS_OF_WEEK = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const
